export default "__VITE_ASSET__$ejAVUBB__"